export default __webpack_public_path__ + "static/eew-logo-small-1e37804a83ea584731cd24ecc3b1bb18.png";